var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiuheatmapactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 6.99997,
    height: 4.6252,
    transform: "matrix(1 0 0 -1 14 4.625)",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 6.99997,
    height: 4.6252,
    transform: "matrix(1 0 0 -1 14 9.3125)",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 6.99997,
    height: 4.6252,
    transform: "matrix(1 0 0 -1 14 14)",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 6.99997,
    height: 4.6252,
    transform: "matrix(1 0 0 -1 7 4.625)",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 6.99997,
    height: 4.6252,
    transform: "matrix(1 0 0 -1 7 9.3125)",
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 6.99997,
    height: 4.6252,
    transform: "matrix(1 0 0 -1 7 14)",
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 14.5,
    width: 6.99997,
    height: 4.6252,
    transform: "rotate(180 7.5 14.5)",
    stroke: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.125,
    width: 6.99997,
    height: 4.6252,
    transform: "rotate(180 7.5 5.125)",
    stroke: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9.8125,
    width: 6.99997,
    height: 4.6252,
    transform: "rotate(180 7.5 9.8125)",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiuheatmapactive);
export default __webpack_public_path__ + "static/media/biểu đồ heat map active.4b31a3ba9cfa5d68d52b61fafa2df6dd.svg";
export { ForwardRef as ReactComponent };